import React from 'react';

// The three control-mode symbols, the same drawings the panel touchscreen and
// the phone show, so an operator looking at any of the three surfaces sees the
// same picture for the mode the dryer is in. Plain inline SVG, no icon
// library involved, copied across rather than shared because the three apps
// have no common package.

const LocalIcon = ({ s = 24, c = 'currentColor' }) => (
  <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="24" stroke={c} strokeWidth="2.5" fill="none"/>
    <circle cx="32" cy="32" r="18" stroke={c} strokeWidth="1" fill="none" opacity="0.2"/>
    <circle cx="32" cy="32" r="12" stroke={c} strokeWidth="1" fill="none" opacity="0.15"/>
    <path d="M32 32 L46 20" stroke={c} strokeWidth="3" strokeLinecap="round"/>
    <circle cx="32" cy="32" r="4" fill={c} opacity="0.4"/>
    {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => {
      const r = (a * Math.PI) / 180;
      return (
        <line
          key={a}
          x1={32 + 21 * Math.cos(r)}
          y1={32 + 21 * Math.sin(r)}
          x2={32 + 24 * Math.cos(r)}
          y2={32 + 24 * Math.sin(r)}
          stroke={c}
          strokeWidth="2"
          strokeLinecap="round"
        />
      );
    })}
  </svg>
);

const ManualIcon = ({ s = 24, c = 'currentColor' }) => (
  <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
    <path d="M14 44 A22 22 0 0 1 50 44" stroke={c} strokeWidth="2.5" strokeLinecap="round" fill="none"/>
    <line x1="16" y1="38" x2="19" y2="36" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="20" y1="28" x2="23" y2="29" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="32" y1="22" x2="32" y2="25" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="44" y1="28" x2="41" y2="29" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="48" y1="38" x2="45" y2="36" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="32" y1="44" x2="44" y2="30" stroke={c} strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="32" cy="44" r="3" fill={c}/>
    <path d="M28 52 L28 56 C28 58 30 60 32 60 C34 60 36 58 36 56 L36 52" stroke={c} strokeWidth="2" fill="none"/>
    <line x1="32" y1="48" x2="32" y2="52" stroke={c} strokeWidth="2" strokeLinecap="round"/>
    <line x1="28" y1="52" x2="26" y2="50" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="36" y1="52" x2="38" y2="50" stroke={c} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const AutomaticIcon = ({ s = 24, c = 'currentColor' }) => (
  <svg width={s} height={s} viewBox="0 0 64 64" fill="none">
    <rect x="16" y="16" width="32" height="28" rx="6" stroke={c} strokeWidth="2.5" fill="none"/>
    <circle cx="26" cy="28" r="4" fill={c} opacity="0.3" stroke={c} strokeWidth="1.5"/>
    <circle cx="38" cy="28" r="4" fill={c} opacity="0.3" stroke={c} strokeWidth="1.5"/>
    <circle cx="26" cy="28" r="1.5" fill={c}/>
    <circle cx="38" cy="28" r="1.5" fill={c}/>
    <path d="M26 38 Q32 42 38 38" stroke={c} strokeWidth="2" strokeLinecap="round" fill="none"/>
    <line x1="32" y1="8" x2="32" y2="16" stroke={c} strokeWidth="2"/>
    <circle cx="32" cy="6" r="3" fill={c} opacity="0.3" stroke={c} strokeWidth="1.5"/>
    <line x1="10" y1="28" x2="16" y2="28" stroke={c} strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="48" y1="28" x2="54" y2="28" stroke={c} strokeWidth="2.5" strokeLinecap="round"/>
    <rect x="22" y="44" width="6" height="8" rx="2" stroke={c} strokeWidth="1.5" fill="none"/>
    <rect x="36" y="44" width="6" height="8" rx="2" stroke={c} strokeWidth="1.5" fill="none"/>
  </svg>
);

// Mode accepts either case ('Local' or 'local'); unknown modes get no icon.
export const getModeIcon = (mode, size, color = 'currentColor') => {
  const m = String(mode || '').toLowerCase();
  if (m === 'local') return <LocalIcon s={size} c={color} />;
  if (m === 'manual') return <ManualIcon s={size} c={color} />;
  if (m === 'automatic') return <AutomaticIcon s={size} c={color} />;
  return null;
};

export default getModeIcon;
